import type { Router } from 'vue-router';
import { watch } from 'vue';

import { ADMIN_REDIRECT_ROUTE_NAME, AFFILIATE_REDIRECT_ROUTE_NAME } from '@modules/core/services/router/constants';
import { ERouteNamespace } from '@modules/core/services/router/enums';
import waitAppReady from '@modules/core/utils/waitAppReady';
import { LOGIN_ROUTE_NAME } from '@modules/login/constants';
import { useCurrentNamespace } from '@modules/permissions/composables';

export default async function createLoginLogoutHandler(router: Router): Promise<void> {
  const { namespace } = useCurrentNamespace();
  await waitAppReady();

  watch(namespace, (newValue, oldValue) => {
    if (newValue) {
      // handle case AFFILIATE (supervision) => ADMIN
      if (!(newValue === ERouteNamespace.ADMIN && oldValue === ERouteNamespace.AFFILIATE)) {
        void router.push({
          name: newValue === ERouteNamespace.ADMIN
            ? ADMIN_REDIRECT_ROUTE_NAME
            : AFFILIATE_REDIRECT_ROUTE_NAME,
        });
      }
    } else {
      void router.push({ name: LOGIN_ROUTE_NAME });
    }
  });
}
